module.exports = __webpack_public_path__ + "f1cd5778f4bf5ea3349f2c807716d062.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/CCC_Grey@2x.png
// module id = 109
// module chunks = 0